import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ASML_ASSET_TYPE,
    DEPRECATED,
    ENDPOINT_GET_ASML_STATUS,
    LOADING_FAILED,
    LOADING_STRING,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET,
    DEFAULT_VENDOR_ATTRIBUTES,
    getUpdateAssetMessageAlertWithSite,
    INDUCT_CAMERA_SUB_ASSET_TYPE,
    PRINTER_SUB_ASSET_TYPE,
    VERIFICATION_CAMERA_SUB_ASSET_TYPE,
    MAC_ADDRESS_PREFIX,
    UNASSIGN_PRINTER,
    UNASSIGN_VERIFICATION_CAMERA,
    NO_PRINTER_ASSIGNED,
    NO_VERIFICATION_CAMERA_ASSIGNED
} from "../../../util/Constants";
import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    convertTableJsonToAsset, deepCopyObject,
    getAPIGatewayPostRequest, getAssetLabelFromMac,
    getNodeId,
    logOperationalMetric,
    setAliasToRequest, isResponseCode5xx,
} from "../../../util/Util";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset, updateAssetInPlace
} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

const metricProcessName = "ASML_DEVICE_DETAILS";

export function fetchAsmlComponentDetails(dispatcher, assetSubType) {
    const request = {
        nodeId: getNodeId(),
        assetType: ASML_ASSET_TYPE
    }
    getAsmlComponentDetails(dispatcher, request, assetSubType)
}

export function fetchAsmlDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ASML_ASSET_TYPE
    }
    getAsmlDeviceDetails(dispatcher, request)
}

export function fetchAsmlComponentStatusDetails(dispatcher, model) {
    getAsmlComponentStatusDetails(dispatcher, model)
}

export function fetchAsmlDeviceStatusDetails(dispatcher, model) {
    getAsmlDeviceStatusDetails(dispatcher, model)
}
export function deleteAsmlComponentDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAsmlComponentDetails(dispatcher, request)
}

export function setAsmlComponentDetails(dispatcher, stateValues, assetSubType) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, ASML_ASSET_TYPE, ACTIVE, assetSubType);
    addAsmlComponentDetails(dispatcher, request, assetSubType)
}

export async function setAsmlDeviceDetails(dispatcher, stateValues) {
    const startTime = Date.now();
    var addAsmlDeviceResponse;
    // ASML is not an asset in itself. For creating a new ASML asset we are setting the parentAssetLabel of printer
    // verification camera to the mac address of the induct camera.
    stateValues.printerMac = stateValues.printerMac.toLowerCase();
    stateValues.verificationCameraMac = stateValues.verificationCameraMac.toLowerCase();
    addAsmlDeviceResponse = await updateParentAssetLabel(stateValues.printerMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
    if (stateValues.verificationCameraMac !== "" && addAsmlDeviceResponse.success) {
        addAsmlDeviceResponse = await updateParentAssetLabel(stateValues.verificationCameraMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
    }
    logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", addAsmlDeviceResponse.success,
        addAsmlDeviceResponse.fault);
    fetchAsmlDeviceDetails(dispatcher);
}

export async function updateAsmlDeviceDetails(dispatcher, stateValues) {
    const startTime = Date.now();
    var updateAsmlDeviceResponse = {
        success: true,
        fault: false
    };
    stateValues.inductCameraMac = stateValues.inductCameraMac.toLowerCase();
    stateValues.originalInductCameraMac = stateValues.originalInductCameraMac.toLowerCase();
    stateValues.printerMac = stateValues.printerMac.toLowerCase();
    stateValues.originalPrinterMac = stateValues.originalPrinterMac.toLowerCase();
    stateValues.verificationCameraMac = stateValues.verificationCameraMac.toLowerCase();
    stateValues.originalVerificationCameraMac = stateValues.originalVerificationCameraMac.toLowerCase();

    // This flow is used to update the connection between different asml components. It is also use to assign a
    // printer and verification camera.
    // If old induct camera mac and selected mac is different then we set parentAssetLabel of old printer to null
    // new printer to new induct camera mac. Same for verification camera.
    // If printer/verification camera mac is different we set parentAssetLabel of old printer to null and new printer
    // to selected induct camera mac. We set parentAssetLabel of new printer only if we are not unassigning it. In
    // case of already unassigned printer we don't set the parentAssetLable of old printer to null since the relationship
    // doesn't exist.

    if (stateValues.inductCameraMac !== stateValues.originalInductCameraMac) {
        if (stateValues.printerMac !== stateValues.originalPrinterMac) {
            updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.originalPrinterMac, null)
            if (updateAsmlDeviceResponse.success && stateValues.printerMac !== UNASSIGN_PRINTER.toLowerCase()) {
               updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.printerMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
            }
        } else {
            updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.printerMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
        }

        if (stateValues.verificationCameraMac !== stateValues.originalVerificationCameraMac && updateAsmlDeviceResponse.success) {
            updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.originalVerificationCameraMac, null)
            if (updateAsmlDeviceResponse.success && stateValues.verificationCameraMac !== UNASSIGN_VERIFICATION_CAMERA.toLowerCase()) {
                updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.verificationCameraMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
            }
        } else {
            updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.verificationCameraMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
        }
    } else {
        if (stateValues.printerMac !== stateValues.originalPrinterMac) {
            if (stateValues.originalPrinterMac !== NO_PRINTER_ASSIGNED.toLowerCase()) {
                updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.originalPrinterMac, null)
            }
            if (updateAsmlDeviceResponse.success && stateValues.printerMac !== UNASSIGN_PRINTER.toLowerCase()) {
                updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.printerMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
            }
        }
        if (stateValues.verificationCameraMac !== stateValues.originalVerificationCameraMac) {
            if (stateValues.originalVerificationCameraMac !== NO_VERIFICATION_CAMERA_ASSIGNED.toLowerCase()) {
                updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.originalVerificationCameraMac, null)
            }
            if (updateAsmlDeviceResponse.success && stateValues.verificationCameraMac !== UNASSIGN_VERIFICATION_CAMERA.toLowerCase()) {
                updateAsmlDeviceResponse = await updateParentAssetLabel(stateValues.verificationCameraMac, MAC_ADDRESS_PREFIX + stateValues.inductCameraMac)
            }
        }
    }
    logOperationalMetric(startTime, metricProcessName, "updateAsmlDeviceDetails", updateAsmlDeviceResponse.success,
        updateAsmlDeviceResponse.fault);
    fetchAsmlDeviceDetails(dispatcher);
}

export async function updateAsmlComponentMac(dispatcher, stateValues, mac, assetSubType) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        alert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", false, false);
    } else {
        deleteAsmlComponentDetails(dispatcher, mac);
        setAsmlComponentDetails(dispatcher, stateValues, assetSubType);
    }
}

export function updateAsmlComponentDetails(dispatcher, stateValues, assetSubType) {
    const request = convertTableJsonToAsset(stateValues, ASML_ASSET_TYPE, ACTIVE, assetSubType);
    updateAsmlAsset(dispatcher, request, assetSubType)
}

const extractAsmlComponentInformation = (assetDeviceDetailList, assetSubType) => {
    const model = {
        asmlComponentInformation: {},
        macAddressArray: []
    }
    assetDeviceDetailList.forEach((asmlDeviceDetail) => {
            if (asmlDeviceDetail.assetStatus === ACTIVE && assetSubType === asmlDeviceDetail.assetSubType) {
                model.macAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                const deviceConfig = JSON.parse(asmlDeviceDetail.assetAttributes.deviceConfig);
                model.asmlComponentInformation[asmlDeviceDetail.assetAttributes.mac] = {
                    name: asmlDeviceDetail.assetAttributes.name,
                    mac: asmlDeviceDetail.assetAttributes.mac,
                    ip: asmlDeviceDetail.assetAttributes.ip,
                    id: deviceConfig.id,
                    port: asmlDeviceDetail.assetAttributes.port,
                    vendorAttributes: asmlDeviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: asmlDeviceDetail.assetAttributes.deviceType,
                    assetType: asmlDeviceDetail.assetType,
                    assetSubType: asmlDeviceDetail.assetSubType,
                    divertConfig: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.divertConfig), []),
                    startTime: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).reason, ""),
                    parentAssetLabel: asmlDeviceDetail.parentAssetLabel
                }
            }
        });
    return model;
}

const extractAsmlDeviceInformation = (assetDeviceDetailList) => {
    const model = {
        inductCameraDeviceInformation: {},
        printerDeviceInformation:{},
        verificationCameraDeviceInformation: {},
        usedInductCameraMacAddressArray: [],
        usedPrinterMacAddressArray: [],
        usedVerificationCameraMacAddressArray: [],
        macAddressArray: [],
        allInductCameraMacAddressArray: [],
        allPrinterMacAddressArray: [],
        allVerificationCameraMacAddressArray:[],
    }
        assetDeviceDetailList.forEach((asmlDeviceDetail) => {
            if (asmlDeviceDetail.assetStatus === ACTIVE) {
                if (asmlDeviceDetail.assetSubType === INDUCT_CAMERA_SUB_ASSET_TYPE) {
                    model.allInductCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                }
                if (asmlDeviceDetail.assetSubType === PRINTER_SUB_ASSET_TYPE) {
                    model.allPrinterMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                }
                if (asmlDeviceDetail.assetSubType === VERIFICATION_CAMERA_SUB_ASSET_TYPE) {
                    model.allVerificationCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                }
            }

            if (asmlDeviceDetail.assetStatus === ACTIVE && asmlDeviceDetail.assetSubType === INDUCT_CAMERA_SUB_ASSET_TYPE) {
                assetDeviceDetailList.forEach((asmlChildDeviceDetail) => {
                    if (MAC_ADDRESS_PREFIX + asmlDeviceDetail.assetAttributes.mac === asmlChildDeviceDetail.parentAssetLabel && asmlChildDeviceDetail.assetStatus === ACTIVE) {
                        model.usedInductCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                        model.macAddressArray.push(asmlDeviceDetail.assetAttributes.mac)
                        model.macAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac)
                        model.inductCameraDeviceInformation[asmlDeviceDetail.assetAttributes.mac] =
                            getAssetInformationFromAssetDetails(asmlDeviceDetail);
                        if (asmlChildDeviceDetail.assetSubType === PRINTER_SUB_ASSET_TYPE) {
                            model.usedPrinterMacAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac)
                            model.printerDeviceInformation[asmlChildDeviceDetail.assetAttributes.mac] =
                                getAssetInformationFromAssetDetails(asmlChildDeviceDetail)
                        }
                        if (asmlChildDeviceDetail.assetSubType === VERIFICATION_CAMERA_SUB_ASSET_TYPE) {
                            model.usedVerificationCameraMacAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac)
                            model.verificationCameraDeviceInformation[asmlChildDeviceDetail.assetAttributes.mac] =
                                getAssetInformationFromAssetDetails(asmlChildDeviceDetail)
                        }
                    }
                });
            }
        });
    return model;
}

async function getAsmlComponentStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: model.macAddressArray
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASML_STATUS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceStatusDetails", true, false);
        mergeStatusToModel(response, model)
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceStatusDetails", false, isFault);
        request.macAddressList.forEach((macAddress) => {
            model.asmlComponentInformation[macAddress].assetStatus = LOADING_FAILED
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});
}

async function getAsmlDeviceStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: model.macAddressArray
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASML_STATUS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceStatusDetails", true, false);
        mergeStatusToAsmlModel(response, model)
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceStatusDetails", false, isFault);
        request.macAddressList.forEach((macAddress) => {
            if (model.usedInductCameraMacAddressArray.includes(macAddress)) {
                model.inductCameraDeviceInformation[macAddress].assetStatus = LOADING_FAILED
            }
            if (model.usedPrinterMacAddressArray.includes(macAddress)) {
                model.printerDeviceInformation[macAddress].assetStatus = LOADING_FAILED
            }
            if (model.usedVerificationCameraMacAddressArray.includes(macAddress)) {
                model.verificationCameraDeviceInformation[macAddress].assetStatus = LOADING_FAILED
            }
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});
}

async function getAsmlComponentDetails(dispatcher, request, assetSubType) {
    let pageToken = null;
    let assetDeviceDetailList = [];
    const startTime = Date.now();
    let isSuccess = true
    let isFault = false
    // Get assets
    do {
        const response = await getAssets(request.nodeId, request.assetType, pageToken)
        const assetListResponse = chainWalk(() => response.data.assetDetailsList, []);
        assetDeviceDetailList = assetDeviceDetailList.concat(assetListResponse)
        isSuccess = response.status === 200
        isFault = isResponseCode5xx(response.status)
        pageToken = chainWalk(() => response.data.pageToken, null);
    } while(pageToken)

        // Extract data
        const asmlComponentInformation = extractAsmlComponentInformation(assetDeviceDetailList, assetSubType);

        // Fork status call
        if (asmlComponentInformation.macAddressArray) {
            await getAsmlComponentStatusDetails(dispatcher, asmlComponentInformation)
        }
        // Return data to page
        dispatcher({type: "RECEIVE_DATA", data: asmlComponentInformation});

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceDetails", isSuccess, isFault);
}

async function getAsmlDeviceDetails(dispatcher, request) {
    let assetDeviceDetailList = [];
    let pageToken = null;
    let isSuccess = true;
    let isFault = false;

    // Get assets
    const startTime = Date.now();
    do {
        const response = await getAssets(request.nodeId, request.assetType, pageToken)
        const assetListResponse = chainWalk(() => response.data.assetDetailsList)
        assetDeviceDetailList = assetDeviceDetailList.concat(assetListResponse);
        isSuccess = response.status === 200
        isFault = isResponseCode5xx(response.status)
        pageToken = chainWalk(() => response.data.pageToken, null);
    } while (pageToken)

    // Extract data
    const asmlDeviceInformation = extractAsmlDeviceInformation(assetDeviceDetailList);


    // Fork status call
    if (asmlDeviceInformation.macAddressArray) {
        await getAsmlDeviceStatusDetails(dispatcher, asmlDeviceInformation)
    }

    // Return data to page
    dispatcher({type: "RECEIVE_DATA", data: asmlDeviceInformation});

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAsmlDeviceDetails", isSuccess, isFault);
}


async function setAssetLabelDeprecatedAsmlComponentDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAsmlDeviceDetails", true, false);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAsmlDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function addAsmlComponentDetails(dispatcher, request, assetSubType) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        const isFault = isResponseCode5xx(result.status)
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                alert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                alert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdate = isResponseCode5xx(responseUpdateAsset.status)
                alert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", false, isFaultInUpdate);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAsmlDeviceDetails", true, false);
        }
        fetchAsmlComponentDetails(dispatcher, assetSubType)
    });
}


async function updateAsmlAsset(dispatcher, request, assetSubType) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAsmlComponentDetails(dispatcher, assetSubType)
        return;
    }

    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAsmlDeviceDetails", isSuccess, isFault);
    fetchAsmlComponentDetails(dispatcher, assetSubType);
}

async function updateAsmlComponentMonitoringSchedule(dispatcher, request, assetSubType) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request, chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAsmlDeviceDetails", isSuccess, isFault);
    fetchAsmlComponentDetails(dispatcher, assetSubType);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "aslStatusList" in response.data) {
        response.data.aslStatusList.forEach((singleAsmlDeviceStatusDetail) => {
            model.asmlComponentInformation[singleAsmlDeviceStatusDetail.mac].assetStatus = singleAsmlDeviceStatusDetail.status
        })
    }
}

function mergeStatusToAsmlModel(response, model) {
    if ("data" in response && "aslStatusList" in response.data) {
        response.data.aslStatusList.forEach((singleAsmlDeviceStatusDetail) => {
            if (model.usedInductCameraMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)) {
                model.inductCameraDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus = singleAsmlDeviceStatusDetail.status
            }
            if (model.usedPrinterMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)) {
                model.printerDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus = singleAsmlDeviceStatusDetail.status
            }
            if (model.usedVerificationCameraMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)) {
                model.verificationCameraDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus = singleAsmlDeviceStatusDetail.status
            }
        })
    }
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

export async function updateAsmlComponentMonitoringDetails(dispatcher, stateValues, mac, assetSubType){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAsmlComponentMonitoringSchedule(dispatcher, updatedAsset, assetSubType)
}

const getAssetInformationFromAssetDetails = (asmlDeviceDetail) => {
    const asset = {
        name: asmlDeviceDetail.assetAttributes.name,
        mac: asmlDeviceDetail.assetAttributes.mac,
        ip: asmlDeviceDetail.assetAttributes.ip,
        port: asmlDeviceDetail.assetAttributes.port,
        vendorAttributes: asmlDeviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
        assetStatus: LOADING_STRING,
        deviceType: asmlDeviceDetail.assetAttributes.deviceType,
        assetType: asmlDeviceDetail.assetType,
        assetSubType: asmlDeviceDetail.assetSubType,
        divertConfig: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.divertConfig), []),
        startTime: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).startTime, "0"),
        endTime: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).endTime, "0"),
        reason: chainWalk(() => JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).reason, ""),
        parentAssetLabel: asmlDeviceDetail.parentAssetLabel
    }
    return asset;
}

async function updateParentAssetLabel (childMacAddress, parentMacAddress) {
    const result = {
        success: true,
        fault: false
    }
    const assetResult = await getAssetByAssetLabel(getAssetLabelFromMac(childMacAddress));
    if (assetResult.status === 200) {
        const updatedAsset = deepCopyObject(assetResult.data.asset);
        updatedAsset.assetDetails.parentAssetLabel = parentMacAddress;
        const updateAssetInPlaceResponse = await updateAsset(updatedAsset, chainWalk(() => assetResult.data.asset.assetDetails.creationTime, null));
        const isSuccess = updateAssetInPlaceResponse.status === 200;
        const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
        if (isFault) {
            alert(ALERT_UPDATE_ASSET_MESSAGE);
            result.success = isSuccess
            result.fault = true
        }
    } else {
        alert(ALERT_UPDATE_ASSET_MESSAGE)
        result.success = false
        result.fault = isResponseCode5xx(assetResult.status)
    }
    return result;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/network/AsmlDeviceOverviewNetworkAPI.js